<template>
  <div
    :class="`text-center text-[13px] md:text-[22px] text-white font-medium px-[10px] py-[18px] md:py-[22px] ${data.type}`"
    v-html="data.text"
  ></div>
</template>

<script lang="ts">
import Vue, { PropType } from "vue";
import { DrxBannerData } from "./types";

export default Vue.extend({
  props: {
    data: {
      type: Object as PropType<DrxBannerData>,
      required: true,
    },
  },
});
</script>

<style scoped>
@tailwind utilities;
@tailwind base;
@tailwind components;

.info-banner {
  @apply bg-info-banner;
}

.warning-banner {
  @apply bg-warning-banner;
}

.alert-banner {
  @apply bg-alert-banner;
}

.dark-banner {
  @apply bg-dark-banner;
}
</style>
